/* HOGGAR — interactions (vanilla, sans dépendance). */
if (!window.__harraga) {
  window.__harraga = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const scroller = () => {
    const pw = $('.page-wrapper');
    return pw && pw.scrollHeight > pw.clientHeight && getComputedStyle(pw).overflowY !== 'visible' ? pw.scrollTop : 0;
  };
  const scrollY = () => Math.max(window.scrollY, scroller());

  /* ---------- Header : réduction au scroll ---------- */
  const header = $('[data-hx-header]');
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      header && header.classList.toggle('is-scrolled', scrollY() > 12);
      ticking = false;
    });
  };
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  onScroll();

  /* ---------- Tiroir menu ---------- */
  const drawer = $('#hx-drawer');
  const opener = $('[data-hx-drawer-open]');
  if (drawer && opener) {
    opener.addEventListener('click', () => {
      drawer.showModal();
      opener.setAttribute('aria-expanded', 'true');
    });
    drawer.addEventListener('close', () => opener.setAttribute('aria-expanded', 'false'));
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer || e.target.closest('[data-hx-drawer-close]')) drawer.close();
    });
  }

  /* ---------- Recherche : ouvre la recherche prédictive native si disponible ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-hx-search]');
    const modal = a && document.getElementById('search-modal');
    if (!modal || typeof modal.showDialog !== 'function') return;
    e.preventDefault();
    modal.showDialog();
  });

  /* ---------- Territoires : produit visible tant que le doigt reste appuyé ---------- */
  let pressed = null;
  let pressStart = null;
  let suppressClick = null;
  const release = (keepClick) => {
    if (!pressed) return;
    if (!keepClick && Date.now() - pressStart.t > 350) {
      suppressClick = pressed; // appui long : on regarde, on ne navigue pas
      setTimeout(() => (suppressClick = null), 700);
    }
    pressed.classList.remove('is-pressed');
    pressed = null;
  };
  document.addEventListener('touchstart', (e) => {
    const el = e.target.closest('[data-hg-press]');
    if (!el || e.touches.length > 1) return;
    pressed = el;
    pressStart = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
    el.classList.add('is-pressed');
  }, { passive: true });
  document.addEventListener('touchmove', (e) => {
    if (!pressed) return;
    const t = e.touches[0];
    if (Math.abs(t.clientX - pressStart.x) > 10 || Math.abs(t.clientY - pressStart.y) > 10) release(true); // défilement
  }, { passive: true });
  document.addEventListener('touchend', () => release(false), { passive: true });
  document.addEventListener('touchcancel', () => release(true), { passive: true });
  document.addEventListener('contextmenu', (e) => { if (e.target.closest('[data-hg-press]')) e.preventDefault(); });
  document.addEventListener('click', (e) => {
    if (suppressClick && suppressClick.contains(e.target)) e.preventDefault();
    suppressClick = null;
  }, true);

  /* ---------- Cartes produit : préchargement des images des autres coloris ---------- */
  const preloadSwatch = (b, img) => {
    if (b._hxImg) return b._hxImg;
    const i = new Image();
    i.decoding = 'async';
    if (img && img.sizes) i.sizes = img.sizes;
    if (b.dataset.srcset) i.srcset = b.dataset.srcset;
    i.src = b.dataset.img;
    b._hxImg = i;
    return i;
  };
  const preloadCard = (card) => {
    if (card.dataset.hxPreloaded) return;
    card.dataset.hxPreloaded = '1';
    const img = card.querySelector('.hx-card__img-main');
    $$('[data-hx-swatch][data-img]', card).forEach((b) => { if (b.getAttribute('aria-pressed') !== 'true') preloadSwatch(b, img); });
  };
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 200));
  // Cartes proches de l'écran : préchargement pendant les temps morts ; survol / doigt posé : immédiat
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      idle(() => preloadCard(en.target));
    }), { rootMargin: '300px 0px' });
    const watch = (root = document) => $$('[data-hx-card]', root).forEach((c) => { if (c.querySelectorAll('[data-hx-swatch]').length > 1) io.observe(c); });
    watch();
    document.addEventListener('shopify:section:load', (e) => watch(e.target));
  }
  ['pointerover', 'touchstart', 'focusin'].forEach((type) => document.addEventListener(type, (e) => {
    const card = e.target.closest && e.target.closest('[data-hx-card]');
    if (card) preloadCard(card);
  }, { passive: true }));

  /* ---------- Cartes produit : pastilles de couleur ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-hx-swatch]');
    if (!b) return;
    const card = b.closest('[data-hx-card]');
    if (!card) return;
    card.querySelectorAll('[data-hx-swatch]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    const img = card.querySelector('.hx-card__img-main');
    if (img && b.dataset.img) {
      // Image déjà préchargée : échange immédiat ; sinon on attend qu'elle soit décodée (pas d'image vide)
      const swap = () => {
        if (b.getAttribute('aria-pressed') !== 'true') return;
        if (b.dataset.photo != null) delete img.dataset.hxSwapped; else img.dataset.hxSwapped = '';
        if (b.dataset.srcset) img.srcset = b.dataset.srcset; else img.removeAttribute('srcset');
        img.src = b.dataset.img;
      };
      const pre = preloadSwatch(b, img);
      if (pre.complete && pre.naturalWidth) swap(); else pre.decode().then(swap, swap);
    }
    if (b.dataset.url) card.querySelectorAll('[data-hx-card-url]').forEach((a) => (a.href = b.dataset.url));
    card.querySelectorAll('[data-hx-group]').forEach((g) => (g.hidden = g.dataset.hxGroup !== b.dataset.hxSwatch));
    if (card._hxSwipe) buildSwipe(card);
  });

  /* ---------- Cartes produit : glisser au doigt pour changer de photo (écrans tactiles, 30/10/2026) ----------
     Seulement les photos du coloris choisi (data-imgs de la pastille active, ou data-hx-imgs sans couleur).
     Aucune flèche ni point : le geste suffit. Pas dans les carrousels horizontaux (.hx-rail), pour ne pas gêner leur défilement. */
  function buildSwipe(card) {
    const link = card.querySelector('.hx-card__img');
    if (!link) return;
    const b = card.querySelector('[data-hx-swatch][aria-pressed="true"]') || card.querySelector('[data-hx-swatch]');
    const media = card.querySelector('[data-hx-imgs]');
    const urls = ((b && b.dataset.imgs) || (media && media.dataset.hxImgs) || '').split(' ').filter(Boolean);
    let track = link.querySelector('.hx-card__track');
    if (urls.length < 2) {
      if (track) track.remove();
      link.classList.remove('has-track');
      return;
    }
    const key = urls.join(' ');
    if (track && track.dataset.key === key) return;
    if (!track) {
      track = document.createElement('div');
      track.className = 'hx-card__track';
      link.appendChild(track);
    }
    track.dataset.key = key;
    track.innerHTML = urls.map((u, i) => `<img src="${u}" alt="" loading="${i ? 'lazy' : 'eager'}" decoding="async" draggable="false">`).join('');
    track.scrollLeft = 0;
    link.classList.add('has-track');
  }
  const touchOnly = window.matchMedia('(hover: none)');
  if (touchOnly.matches && 'IntersectionObserver' in window) {
    const swipeIo = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      swipeIo.unobserve(en.target);
      en.target._hxSwipe = true;
      buildSwipe(en.target);
    }), { rootMargin: '400px 0px' });
    const watchSwipe = (root = document) => $$('[data-hx-card]', root).forEach((c) => { if (!c.closest('.hx-rail')) swipeIo.observe(c); });
    watchSwipe();
    document.addEventListener('shopify:section:load', (e) => watchSwipe(e.target));
  }

  /* ---------- Hero : indicateurs des slides (uniquement s'il y en a plusieurs) ---------- */
  $$('[data-hg-slider]').forEach((hero) => {
    const track = $('[data-hg-track]', hero);
    const dots = $$('[data-hg-dot]', hero);
    if (!track || dots.length < 2) return;
    const slides = [...track.children];
    dots.forEach((d) => d.addEventListener('click', () => track.scrollTo({ left: slides[Number(d.dataset.hgDot)].offsetLeft, behavior: 'smooth' })));
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting && e.intersectionRatio > 0.6) dots.forEach((d, i) => d.classList.toggle('is-active', slides[i] === e.target));
    }), { root: track, threshold: [0.6] });
    slides.forEach((sl) => io.observe(sl));
  });

  /* ---------- Collections : filtre par catégorie, instantané (sans rechargement) ---------- */
  $$('[data-hg-typebar]').forEach((bar) => {
    const section = bar.closest('section') || document;
    const items = $$('[data-hg-item-type]', section);
    const tabs = $$('[data-hg-type]', bar);
    const label = $('[data-hg-count-label]', section);
    const count = (t) => items.filter((li) => !t || li.dataset.hgItemType === t).length;
    tabs.forEach((tab) => { const n = count(tab.dataset.hgType); const sup = $('[data-hg-type-count]', tab); if (sup) sup.textContent = n; if (tab.dataset.hgType && !n) tab.hidden = true; });
    const apply = (t, push) => {
      if (!tabs.some((x) => x.dataset.hgType === t)) t = '';
      tabs.forEach((x) => { const on = x.dataset.hgType === t; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on)); });
      items.forEach((li) => (li.hidden = !!t && li.dataset.hgItemType !== t));
      const n = count(t);
      if (label) label.textContent = `${n} pièce${n > 1 ? 's' : ''}`;
      if (push) {
        if (!label) return; // page d'accueil : pas de paramètre dans l'adresse
        const url = new URL(location.href);
        t ? url.searchParams.set('type', t) : url.searchParams.delete('type');
        history.replaceState(history.state, '', url);
      }
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      apply(tab.dataset.hgType, true);
      const top = bar.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      tab.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }));
    apply(label ? new URL(location.href).searchParams.get('type') || '' : '', false);
  });

  /* ---------- Panier ---------- */
  const setCount = (n) => {
    $$('[data-hx-cart-count]').forEach((el) => { el.textContent = n; el.hidden = !n; });
    $$('[data-hx-cart]').forEach((el) => {
      el.setAttribute('aria-label', `Panier, ${n} article${n > 1 ? 's' : ''}`);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  };
  const refreshCount = () =>
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => (setCount(c.item_count), c));

  const cartDrawer = () => {
    const d = document.getElementById('cart-drawer');
    return d && typeof d.open === 'function' ? d : null;
  };
  $$('[data-hx-cart]').forEach((a) =>
    a.addEventListener('click', (e) => {
      const d = cartDrawer();
      if (d && !location.pathname.endsWith('/cart')) {
        e.preventDefault();
        d.open();
      }
    })
  );
  document.addEventListener('shopify:cart:lines-update', (e) => {
    if (e.detail && e.detail.source === 'harraga') return;
    const p = e.promise || (e.detail && e.detail.promise);
    (p && p.then ? p.then(() => refreshCount()) : setTimeout(refreshCount, 800));
  });

  let EventsMod = null;
  import('@shopify/events').then((m) => (EventsMod = m)).catch(() => {});

  const toast = (msg, isError) => {
    let t = $('.hx-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'hx-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-on'), 2600);
  };

  const addToCart = async (form, submitter) => {
    const fd = new FormData(form);
    if (submitter && submitter.name === 'id') fd.set('id', submitter.value);
    const id = fd.get('id');
    const btn = submitter || form.querySelector('[type=submit]');
    if (!id) {
      const sel = form.querySelector('select[name=id]');
      sel && sel.focus();
      toast('Choisis d’abord une taille.', true);
      return;
    }
    if (!fd.get('quantity')) fd.set('quantity', '1');
    const ids = $$('cart-items-component')
      .map((c) => c.dataset.sectionId)
      .filter(Boolean);
    if (ids.length) fd.set('sections', ids.join(','));

    btn && btn.classList.add('is-busy');
    let deferred = null;
    const Ev = EventsMod && EventsMod.CartLinesUpdateEvent;
    if (Ev && typeof Ev.createPromise === 'function') {
      deferred = Ev.createPromise();
      form.dispatchEvent(
        new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: Number(fd.get('quantity')) }], promise: deferred.promise })
      );
    }
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      const cart = await refreshCount();
      if (deferred) {
        deferred.resolve({
          cart: Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(cart) : cart,
          detail: { items: cart.items, source: 'harraga', itemCount: 1, sections: data.sections, didError: false },
        });
      }
      btn && btn.classList.add('is-done');
      setTimeout(() => btn && btn.classList.remove('is-done'), 1600);
      const d = cartDrawer();
      if (d && !d.isOpen) d.open();
      else if (!d) toast('Ajouté au panier.');
      const pick = form.closest('.hx-pick');
      if (pick) closePick(pick);
    } catch (err) {
      deferred && deferred.resolve({ cart: null, detail: { didError: true, source: 'harraga' } });
      toast(err.message || 'Impossible d’ajouter ce produit.', true);
    } finally {
      btn && btn.classList.remove('is-busy');
    }
  };
  // Le clic sur le bouton est intercepté avant la soumission du formulaire : Shopify compte un ajout au panier
  // à la soumission d'un formulaire « /cart/add » ET à l'appel Ajax, ce qui doublait l'événement envoyé à Google et Facebook.
  document.addEventListener('click', (e) => {
    // btn.form couvre aussi le bouton de la barre d'achat fixe, placé hors du formulaire (attribut form="…")
    const btn = e.target.closest('button[type=submit], button:not([type])');
    if (!btn || btn.disabled) return;
    const form = btn.form;
    if (!form || !form.hasAttribute('data-hx-quick-add')) return;
    e.preventDefault();
    if (typeof form.checkValidity === 'function' && !form.hasAttribute('novalidate') && !form.checkValidity()) { form.reportValidity(); return; }
    addToCart(form, btn);
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-hx-quick-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, e.submitter);
  });

  /* ---------- Choix de taille sur les cartes ----------
     Un même produit peut apparaître plusieurs fois sur une page (onglets, bannières…) :
     chaque bouton « + » pilote toujours le panneau de SA carte, et les identifiants sont rendus uniques. */
  const pickOf = (t) => t.parentElement.querySelector('.hx-pick');
  const buttonOf = (p) => p.parentElement.querySelector('[data-hx-pick]');
  const uniquePickIds = (root = document) => $$('[data-hx-pick]', root).forEach((t) => {
    const p = pickOf(t);
    if (!p || p.dataset.hxUid) return;
    p.dataset.hxUid = '1';
    p.id = `${p.id}-${Math.random().toString(36).slice(2, 8)}`;
    t.setAttribute('aria-controls', p.id);
  });
  uniquePickIds();
  document.addEventListener('shopify:section:load', (e) => uniquePickIds(e.target));
  const closePick = (pick) => {
    pick.hidden = true;
    const b = buttonOf(pick);
    b && b.setAttribute('aria-expanded', 'false');
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-hx-pick]');
    const pick = t && pickOf(t);
    $$('.hx-pick:not([hidden])').forEach((p) => {
      if (!p.contains(e.target) && p !== pick) closePick(p);
    });
    if (!pick) return;
    const open = pick.hidden;
    pick.hidden = !open;
    t.setAttribute('aria-expanded', String(open));
    if (open) {
      const group = [...pick.querySelectorAll('[data-hx-group]')].find((g) => !g.hidden) || pick;
      const first = group.querySelector('button:not([disabled])');
      first && first.focus({ preventScroll: true });
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.hx-pick:not([hidden])').forEach((p) => {
      closePick(p);
      const b = buttonOf(p);
      b && b.focus();
    });
  });

  /* ---------- Favoris (mémorisés sur l'appareil) ---------- */
  let favs = [];
  try { favs = JSON.parse(localStorage.getItem('hx-favs') || '[]'); } catch (_) { favs = []; }
  const paintFavs = () => $$('[data-hx-fav]').forEach((b) => b.setAttribute('aria-pressed', String(favs.includes(b.dataset.hxFav))));
  paintFavs();
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-hx-fav]');
    if (!b) return;
    const h = b.dataset.hxFav;
    favs = favs.includes(h) ? favs.filter((x) => x !== h) : [...favs, h];
    try { localStorage.setItem('hx-favs', JSON.stringify(favs)); } catch (_) {}
    paintFavs();
  });

  /* ---------- Rails : flèches desktop ---------- */
  $$('[data-hx-arrows]').forEach((arrows) => {
    const section = arrows.closest('section');
    const rail = section && $('[data-hx-rail]', section);
    if (!rail) return;
    const prev = $('[data-hx-prev]', arrows);
    const next = $('[data-hx-next]', arrows);
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth - 2;
      arrows.classList.toggle('is-active', max > 0);
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    };
    const step = (dir) => rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    rail.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(rail);
  });

  /* ---------- Avis ---------- */
  $$('[data-hx-reviews]').forEach((sec) => {
    const items = $$('.hx-review', sec);
    if (items.length < 2) return;
    let i = 0;
    const show = (n) => {
      i = (n + items.length) % items.length;
      items.forEach((it, k) => (it.hidden = k !== i));
    };
    $('[data-hx-review-prev]', sec).addEventListener('click', () => show(i - 1));
    $('[data-hx-review-next]', sec).addEventListener('click', () => show(i + 1));
  });

  /* ---------- Barre produit fixe ---------- */
  const sticky = $('[data-hx-sticky]');
  if (sticky) {
    sticky.hidden = false;
    const hero = $('[data-hx-hero]');
    const footer = $('.hx-footer');
    let pastHero = !hero;
    let footerIn = false;
    const paint = () => {
      const on = pastHero && !footerIn;
      sticky.classList.toggle('is-visible', on);
      sticky.inert = !on;
      document.body.classList.toggle('hx-has-sticky', on);
    };
    if (hero) new IntersectionObserver(([e]) => ((pastHero = !e.isIntersecting), paint()), { threshold: 0 }).observe(hero);
    if (footer) new IntersectionObserver(([e]) => ((footerIn = e.isIntersecting), paint()), { threshold: 0.05 }).observe(footer);
    paint();
  }

  /* ---------- Sélecteurs à soumission automatique ---------- */
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-hx-autosubmit]');
    if (s && s.form) s.form.submit();
  });
}
